import {
  ArrowUpRight,
  Building2,
  Check,
  ChevronRight,
  CircleHelp,
  Copy,
  Eye,
  EyeOff,
  Link,
  LogOut,
  Maximize2,
  Menu,
  Minimize2,
  Moon,
  Search,
  Sun,
  X,
} from "lucide-react";

// This adapter preserves the small legacy Iconify call-site contract while
// keeping the shell on its single icon system. The old Iconify runtime added a
// second icon engine to the initial authenticated download for a handful of
// stable shell glyphs.
const ICONS = Object.freeze({
  "mdi:close": X,
  "mdi:menu": Menu,
  "mdi:domain": Building2,
  "mdi:chevron-right": ChevronRight,
  "mdi:apps": Building2,
  "mdi:white-balance-sunny": Sun,
  "mdi:weather-night": Moon,
  "mdi:arrow-collapse": Minimize2,
  "mdi:arrow-expand": Maximize2,
  "mdi:content-copy": Copy,
  "mdi:link-variant": Link,
  "mdi:logout": LogOut,
  "mdi:magnify": Search,
  "mdi:check": Check,
  "mdi:arrow-top-right": ArrowUpRight,
  "eva:eye-fill": Eye,
  "eva:eye-off-fill": EyeOff,
});

export default function Iconify({ icon, sx, style, width, height, size, ...other }) {
  const Glyph = ICONS[icon] || CircleHelp;
  const resolvedSize = size || width || height || 18;

  return (
    <Glyph
      size={resolvedSize}
      width={width}
      height={height}
      style={{ ...(sx || {}), ...(style || {}) }}
      {...other}
    />
  );
}
